export default __webpack_public_path__ + "static/logo-samsungfire-3e13ac9168af491378b3f99f05f22eda.jpg";